__turbopack_context__.v({
  "content": "style-module-scss-module__djMNaG__content",
  "root": "style-module-scss-module__djMNaG__root",
});
